export default "__VITE_ASSET__De$6s6wC__"